<template>
  <div>
    <v-app-bar app color="white darken-2">
      <v-app-bar-nav-icon
        color="black"
        @click="drawer = !drawer"
      ></v-app-bar-nav-icon>
      <v-toolbar-title class="black--text">
        <v-btn class="black--text" @click="goHome" text tile depressed>
          Robin Lange
        </v-btn>
      </v-toolbar-title>
    </v-app-bar>
    <v-navigation-drawer v-model="drawer" absolute temporary>
      <v-list nav>
        <v-list-item
          v-for="(item, index) in mainLinks"
          :key="index"
          :to="item.link"
        >
          <v-list-item-title>{{ item.name }}</v-list-item-title>
        </v-list-item>
      </v-list>
      <v-expansion-panels flat tile>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <div>
              <span>Tools</span>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-list dense>
              <v-list-item
                v-for="(tItem, index) in toolLinks"
                :key="index"
                :to="tItem.link"
              >
                <v-list-item-content>
                  {{ tItem.name }}
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-navigation-drawer>
  </div>
</template>

<script>
export default {
  name: "AppBar",
  data: () => ({
    drawer: false,
    mainLinks: [
      { name: "Home", link: "/", icon: "fa-home" },
      { name: "About", link: "/about", icon: "fa-question" },
      { name: "Blog", link: "/blog", icon: "fa-underline" },
    ],
    toolLinks: [
      { name: "Plate Calculator", link: "/platecalc", icon: "mdi-calculator" },
      { name: "BMR Calculator", link: "/bmrcalc", icon: "mdi-scale" },
      { name: "Macro Calculator", link: "/macrocalc", icon: "mdi-food" },
    ],
    servicesLinks: [
      {
        name: "Calculators",
        link: "/services/customcalc",
        icon: "fa-calculator",
      },
      {
        name: "Forms",
        link: "/services/customcalc",
        icon: "fa-keyboard",
      },
      {
        name: "Dashboards",
        link: "/services/customcalc",
        icon: "fa-tachometer-alt",
      },
    ],
  }),
  methods: {
    goHome() {
      this.$router.push("/");
    },
  },
};
</script>

<style></style>
